import { render, staticRenderFns } from "./give-service-item.vue?vue&type=template&id=69e33322&scoped=true"
import script from "./give-service-item.vue?vue&type=script&lang=js"
export * from "./give-service-item.vue?vue&type=script&lang=js"
import style0 from "./give-service-item.vue?vue&type=style&index=0&id=69e33322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e33322",
  null
  
)

export default component.exports